import React from 'react';

import clsx from 'clsx';

import { EmployeeDisplayProps } from 'actions/application';
import { DashboardLabelName } from 'enums/DashboardLabelName';
import { maskMonetaryValueAllowZero } from 'utils/stringUtils';

import styles from './DashboardTopInfo.module.scss';

interface DashboardTopInfoProps {
  label: DashboardLabelName | string;
  loanAmount?: number;
  createdDate?: Date;
  applicationId?: string;
  processorInfo?: EmployeeDisplayProps;
}

const getDateWithFormat = (rawDate: string | Date) => {
  const date = new Date(rawDate);

  return `${date.toLocaleString('en-US', { day: '2-digit', year: 'numeric', month: 'short' })},
    ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
};

const getStylesByLabel = (label: string) => {
  switch (label) {
    case DashboardLabelName.NewInquiry:
      return styles.labelNewInquiry;

    case DashboardLabelName.Processing:
      return styles.labelProcessing;

    case DashboardLabelName.Denied:
      return styles.labelDenied;

    case DashboardLabelName.Underwriting:
      return styles.labelUnderwriting;

    case DashboardLabelName.Approved:
      return styles.labelApproved;

    case DashboardLabelName.Funded:
      return styles.labelFunded;

    case DashboardLabelName.Prequalified:
      return styles.labelPrequalified;

    case DashboardLabelName.Declined:
      return styles.labelDeclined;
  }
};

const DashboardTopInfo = ({ label, loanAmount, createdDate, applicationId, processorInfo }: DashboardTopInfoProps) => {
  return (
    <div className={styles.dashboardTopInfoContainer}>
      <div className={styles.status}>
        <div className={styles.loanAmountContainer}>
          {loanAmount && <div className={styles.loanAmount}>{maskMonetaryValueAllowZero(loanAmount.toString())}</div>}
          <div className={clsx(styles.label, getStylesByLabel(label))}>{label}</div>
        </div>
        <div className={styles.applicationIdAndCreateDate}>
          {applicationId && <div className={styles.applicationId}>{`ID #${applicationId}`}</div>}
          {createdDate && <div className={styles.dateAndTime}>{getDateWithFormat(createdDate)}</div>}
        </div>
      </div>
      {processorInfo?.name && (
        <div className={styles.processorInfoContainer}>
          {[`${processorInfo.name}, ${processorInfo.position}`, processorInfo.phone, processorInfo.email].map(
            (value, index) => (
              <div className={clsx(index === 2 && styles.email)} key={index}>
                {value}
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardTopInfo;
